import { ReactNode } from 'react';

import { StatusBubble } from 'components/Display/StatusBubble/StatusBubble';

type Props = {
  variant: 'error' | 'warning';
  label: ReactNode;
};

export const AnnotationsLabel = ({ variant, label }: Props) => (
  <span className="inline-flex items-center gap-2 text-xs leading-4 font-medium text-gray-700">
    <StatusBubble variant={variant} />
    {label}
  </span>
);
